import React from "react";

const FIELDS = [
  { key: "chest", label: "Chest" },
  { key: "length", label: "Length" },
  { key: "sleeve", label: "Sleeve" },
  { key: "shoulder", label: "Shoulder" },
  { key: "waist", label: "Waist" },
  { key: "hem", label: "Hem" },
];
const SIZES = ["S", "M", "L", "XL"];

const DimensionTable = ({ dimensions, onChange, readOnly = false }) => {
  const set = (size, key, val) => {
    const num = val === "" ? 0 : parseFloat(val);
    const next = {
      ...dimensions,
      [size]: { ...(dimensions?.[size] || {}), [key]: isNaN(num) ? 0 : num },
    };
    onChange(next);
  };

  return (
    <div className="border border-zinc-800 bg-[#050505]" data-testid="dimension-table">
      <div className="grid grid-cols-[60px_repeat(6,1fr)] text-[10px] tracking-[0.2em] uppercase text-zinc-500 font-bold border-b border-zinc-800">
        <div className="p-3 border-r border-zinc-800 bg-[#0a0a0a]">Size</div>
        {FIELDS.map((f) => (
          <div key={f.key} className="p-3 border-r border-zinc-800 last:border-r-0 bg-[#0a0a0a]">
            {f.label} <span className="text-zinc-600 normal-case">(cm)</span>
          </div>
        ))}
      </div>
      {SIZES.map((size) => (
        <div
          key={size}
          className="grid grid-cols-[60px_repeat(6,1fr)] border-b border-zinc-800 last:border-b-0 hover:bg-[#0a0a0a]/50 transition-colors"
        >
          <div className="p-3 border-r border-zinc-800 flex items-center justify-center font-display text-xl text-[#ff3333]">
            {size}
          </div>
          {FIELDS.map((f) => (
            <div key={f.key} className="border-r border-zinc-800 last:border-r-0">
              <input
                type="number"
                step="0.1"
                readOnly={readOnly}
                data-testid={`dim-${size}-${f.key}`}
                value={dimensions?.[size]?.[f.key] ?? 0}
                onChange={(e) => set(size, f.key, e.target.value)}
                className="w-full h-full bg-transparent text-white font-mono text-sm px-3 py-3 outline-none focus:bg-[#ff3333]/10 focus:text-[#ff3333] transition-colors"
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default DimensionTable;
